module.exports = __webpack_public_path__ + "static/media/edition.07d9ebce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solution_icon/edition.svg
// module id = 672
// module chunks = 0